<section class="invite-details">
    <header class="row page-header">
        <div class="row">
            <div class="col-md-12">
                <h2 class="title">Join SmartProperty</h2>
            </div>
        </div>
    </header>

    <main>
        <div class="row">
            <div class="col-md-12">
                <h3 *ngIf="requireConfirmPassword">Register to accept the invitation.</h3>
                <h3 *ngIf="!requireConfirmPassword">Sign in to accept the invitation.</h3>
            </div>
        </div>

        <div class="form-section">
            <sp-comm-state [successMessage]="'Join success'"
                           [failedMessage]="'Unable to join SmartProperty'"
                           [scrollOnStateChange]="true"
                           [scrollItemSelector]="'body'"></sp-comm-state>
            <div class="login-link" [hidden]="!showSigninLink">If you have a SmartProperty account, click <a routerLink="/signin" routerLinkActive="active">here</a> to sign in.</div>

            <form [formGroup]="inviteDetailsForm" *ngIf="email">
                <div class="row">
                    <div class="col-md-10">
                        <div>
                            <div class="row top-buffer-20">
                                <div class="col-md-2">
                                    <label class="small">First Name</label>
                                </div>
                                <div class="col-md-6">
                                    <div *ngIf="requireConfirmPassword">
                                        <input type="text" formControlName="firstName" pattern="[a-zA-Z0-9\.\-\s_]{0,50}" maxlength="50" minlength="3" class="form-control" placeholder="First Name"
                                        />
                                        <span [hidden]="firstName.untouched || firstName.valid" class="red">
											<span *ngIf="firstName.errors && firstName.errors.pattern">Only 'Alphanumeric', 'underscore' and 'Dash' characters allowed</span>
										</span>
                                    </div>
                                    <div *ngIf="!requireConfirmPassword">
                                        <label>{{firstName.value}}</label>
                                    </div>
                                </div>
                            </div>

                            <div class="row top-buffer-20">
                                <div class="col-md-2">
                                    <label class="small">Last Name</label>
                                </div>
                                <div class="col-md-6">
                                    <div *ngIf="requireConfirmPassword">
                                        <input type="text" formControlName="lastName" pattern="[a-zA-Z0-9\.\-\s_]{0,50}" maxlength="50" minlength="3" class="form-control" placeholder="Last Name"
                                        />
                                        <span [hidden]="lastName.untouched || lastName.valid" class="red">
											<span *ngIf="lastName.errors && lastName.errors.pattern">Only 'Alphanumeric', 'underscore' and 'Dash' characters allowed</span>
										</span>
                                    </div>
                                    <div *ngIf="!requireConfirmPassword">
                                        <label>{{lastName.value}}</label>
                                    </div>
                                </div>
                            </div>

                            <div class="row top-buffer-20">
                                <div class="col-md-2">
                                    <label class="small">Email</label>
                                </div>
                                <div class="col-md-6">
                                    <label>{{email}}</label>
                                </div>
                            </div>

                                <div class="row top-buffer-20">
                                    <div class="col-md-2">
                                        <label class="small">Password</label>
                                    </div>
                                    <div class="col-md-6">
                                        <input type="password" formControlName="password" class="form-control" placeholder="Password" maxlength="20"
                                        />
                                        <span class="info" *ngIf="requireConfirmPassword">Passwords must have at least six characters that includes: lowercase letters, numbers, and symbols.</span>
                                    </div>
                                </div>

                            <div *ngIf="requireConfirmPassword">
                                <div class="row top-buffer-20">
                                    <div class="col-md-2">
                                        <label class="small">Confirm Password</label>
                                    </div>
                                    <div class="col-md-6">
                                        <input type="password" formControlName="confirmPassword" class="form-control" placeholder="Confirm Password" maxlength="20"
                                        />
                                        <sp-field-error [controlName]="'Confirm Password'" [control]="inviteDetailsForm?.controls?.confirmPassword"></sp-field-error>
                                    </div>
                                </div>
                            </div>

                            <div class="row top-buffer-20">
                                <div class="col-md-6 offset-md-2">
                                    <button [disabled]="!inviteDetailsForm?.valid || isSubmitting" type="submit" (click)="onJoin()" class="btn btn-success btn-register">
                                        <span *ngIf="isSubmitting" class="sp-icon-loader-button-secondary u-alignMiddle"></span>{{requireConfirmPassword ? (isSubmitting ? 'Accepting...' : 'Register &amp; Accept') : (isSubmitting? 'Accepting...' : 'Sign In &amp; Accept') }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </main>
</section>
